import React, { useLayoutEffect } from 'react';
import styles from './style.module.scss';
import { Card, Col, Row, Table } from 'antd';
import { useTranslation } from 'react-i18next';
import useBreadcrumb from 'hooks/useBreadcrumb';
import Filters from 'components/filters';
import usePromotions from '../usePromotions';
import { Route, Routes } from 'react-router-dom';
import DeleteModal from '../../../../components/deleteModalView';
import ViewModal from './viewModal';

const TeamList = () => {
  const { t } = useTranslation();
  const { addNewBreadcrumb, removeLastBreadcrumb } = useBreadcrumb();
  const {
    filters,
    columns,
    data,
    loading,
    onChangeTableFilter,
    updateInProcess,
    onDelete,
    singleItem,
  } = usePromotions(true);

  useLayoutEffect(() => {
    removeLastBreadcrumb('/promotions/list');
    addNewBreadcrumb(t('Le tue promozioni'), '/promotions/list');
    return () => {
      removeLastBreadcrumb('/promotions/list');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Card className={styles.card} title={t('Le tue promozioni')}>
      <Row>
        <Col span={24}>
          <Filters filters={filters} />
        </Col>
        <Col span={24}>
          <br />
          <Table
            bordered
            dataSource={data.promotions}
            pagination={data.pagination}
            onChange={onChangeTableFilter}
            columns={columns}
            scroll={{ x: 800 }}
            loading={loading}
          />
        </Col>
      </Row>
      <Routes>
        <Route
          path={':id/delete'}
          element={
            <DeleteModal loading={updateInProcess} onClickDelete={onDelete} />
          }
        />
        <Route
          path={':id/view'}
          element={<ViewModal singleItem={singleItem} />}
        />
      </Routes>
    </Card>
  );
};

export default TeamList;
